import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { initialSection: String, scrollOnTabSwitch: Boolean }
  static targets = ["tab", "section"]
  static classes = ["sectionToggle", "tabToggle"]

  renderer = {
    set: (target, property, value) => {
      target[property] = value

      this.renderer.toggleCurrentSection(property)

      return true
    },
    toggleCurrentSection: (property) => {
      if (property !== "currentSectionSelector") return

      this.sectionTargets.forEach((section) => section.classList.remove(this.sectionToggleSelector))
      this.tabTargets.forEach((tab) => tab.classList.remove(this.tabToggleSelector))

      this.currentSectionElement.classList.add(this.sectionToggleSelector)
      this.currentTabElement.classList.add(this.tabToggleSelector)
    }
  }

  initialize() {
    this.hashChangeBind = this.loadTabFromAnchor.bind(this)
    this.state = new Proxy({}, this.renderer)
    if (this.hasInitialSectionValue) {
      this.state.currentSectionSelector = this.initialSectionValue
    }
  }

  connect() {
    window.addEventListener("hashchange", this.hashChangeBind)
    // Check if the current anchor is a valid tab when connecting
    this.loadTabFromAnchor()
  }

  disconnect() {
    window.removeEventListener("hashchange", this.hashChangeBind)
  }

  show(event) {
    event.preventDefault()
    const currentHref = event.currentTarget.getAttribute("href")

    const hashPortion = currentHref.split("#")[1]
    if (hashPortion) window.location.hash = hashPortion
  }

  loadTabFromAnchor(event) {
    const anchor = window.location.hash
    if (!anchor) return

    if (this.isTabAvailable(anchor)) {
      this.switchTab(anchor)
    }
  }

  isTabAvailable(tab) {
    if (!tab) return false

    return Array.from(this.tabTargets).some(tabElement => {
      return tabElement.hash.includes(tab)
    })
  }

  switchTab(tab) {
    this.state.currentSectionSelector = tab

    if (this.scrollOnTabSwitchValue === true) {
      this.currentSectionElement.scrollIntoView({behavior: "smooth"})
    }
  }

  get currentSectionElement() {
    return this.sectionTargets.find((el) => el.matches(this.state.currentSectionSelector))
  }

  get currentTabElement() {
    return this.tabTargets.find((el) => el.matches(`a[href="${this.state.currentSectionSelector}"]`))
  }

  get sectionToggleSelector() {
    if (this.hasSectionToggleClass) {
      return this.sectionToggleClass
    } else {
      return "element--on"
    }
  }

  get tabToggleSelector() {
    if (this.hasTabToggleClass) {
      return this.tabToggleClass
    } else {
      return "tab__link--active"
    }
  }
}
